<template>
  <div class="log__item">
    <div class="log__date">
      {{ date }}
      {{ truncatedTime }}
    </div>

    <!-- WHITELIST PLACEMENTS -->
    <template v-if="action === logTypes.PLACEMENTS_WHITELIST_ADD">
      <div class="log__message">
        <router-link
          class="link"
          :to="{ name: 'action-log-placements', params: { id } }"
        >{{ $tc('c.logList.subjectPlacements', count) }}</router-link>
        {{ $tc('c.logList.actionWhitelistAddPlacements', count) }}.
      </div>
    </template>
    <template v-else-if="action === logTypes.PLACEMENTS_WHITELIST_DELETE">
      <div class="log__message">
        <router-link
          class="link"
          :to="{ name: 'action-log-placements', params: { id } }"
        >{{ $tc('c.logList.subjectPlacements', count) }}</router-link>
        {{ $tc('c.logList.actionWhitelistDeletePlacements', count) }}.
      </div>
    </template>
    <template v-else-if="action === logTypes.PLACEMENTS_WHITELIST_SWITCH">
      <div class="log__message">
        <router-link
          class="link"
          :to="{ name: 'action-log-placements', params: { id } }"
        >{{ $tc('c.logList.subjectPlacements', count) }}</router-link>
        {{ $tc('c.logList.actionMovedFromBlacklistToWhitelist', count) }}.
      </div>
    </template>

    <!-- BLACKLIST PLACEMENTS -->
    <template v-else-if="action === logTypes.PLACEMENTS_PERSONAL_BLACKLIST_ADD">
      <div class="log__message">
        <router-link
          class="link"
          :to="{ name: 'action-log-placements', params: { id } }"
        >{{ $tc('c.logList.subjectPlacements', count) }}</router-link>
        {{ $tc('c.logList.actionAddFeminine', count) }}
        {{ $t('c.logList.toPersonalBlackList') }}.
      </div>
    </template>
    <template v-else-if="action === logTypes.PLACEMENTS_PERSONAL_BLACKLIST_DELETE">
      <div class="log__message">
        <router-link
          class="link"
          :to="{ name: 'action-log-placements', params: { id } }"
        >{{ $tc('c.logList.subjectPlacements', count) }}</router-link>
        {{ $tc('c.logList.actionDeleteFeminine', count) }}
        {{ $t('c.logList.fromPersonalBlackList') }}.
      </div>
    </template>

    <!-- PLACEMENTS -->
    <template v-else-if="action === logTypes.PLACEMENTS_WORST_AUTODISABLE">
      <div class="log__message">
        <router-link
          class="link"
          :to="{ name: 'action-log-placements', params: { id } }"
        >{{ $tc('c.logList.subjectPlacements', count) }}</router-link>
        {{ $tc('c.logList.actionAutoexcludeFeminine', count) }}.
      </div>
    </template>

    <template v-else-if="action === logTypes.PLACEMENTS_NETWORK_DISABLE">
      <div class="log__message">{{ $t('c.logList.messagePlacementsNetworkDisable') }}.</div>
    </template>

    <template v-else-if="action === logTypes.PLACEMENTS_NETWORK_ENABLE">
      <div class="log__message">{{ $t('c.logList.messagePlacementsNetworkEnable') }}.</div>
    </template>

    <template v-else>
      <div class="log__message log__message--gray">{{ $t('c.logList.messageNoActions') }}.</div>
    </template>
  </div>
</template>

<script>
import * as logTypes from '@/constants/logTypes'

export default {
  name: 'VActionLogListItem',

  props: {
    id: {
      type: [String, Number],
      required: true
    },
    action: {
      type: String,
      required: true
    },
    created: {
      type: String,
      required: true
    },
    count: {
      type: Number
    }
  },

  data: () => ({
    logTypes
  }),

  computed: {
    truncatedTime() {
      return this.time.split('.')[0]
    },
    date() {
      const date = new Date(this.created)
      const y = date.getUTCFullYear()
      const m = date.getUTCMonth() + 1
      const d = date.getUTCDate()

      return `${y}-${m < 10 ? `0${m}` : m}-${d < 10 ? `0${d}` : d}`
    },
    time() {
      const date = new Date(this.created)
      const h = date.getUTCHours()
      const m = date.getUTCMinutes()
      const s = date.getUTCSeconds()

      return `${h < 10 ? `0${h}` : h}:${m < 10 ? `0${m}` : m}:${
        s < 10 ? `0${s}` : s
      }`
    }
  }
}
</script>
